
export interface ContactFormData {
    name: string;
    email: string;
    companyName?: string;
    roomCount?: string;
    phoneNumber: string;
    postalCode?: string;
    source: string;
    message: string;
}

export const sendContactForm = async (formData: ContactFormData) => {
    try {

        const response = await fetch('/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(
                data?.error || data?.message || 'Failed to send contact form'
            );
        }

        return data;

    } catch (error) {
        console.error(
            'Error sending contact form:',
            error
        );

        throw error;
    }
};

export interface DemoRequestData {
    guest_name: string;
    guest_email: string;
    language: string;
}

export const sendDemoRequest = async (data: DemoRequestData) => {
    try {

        const response = await fetch('/api/demo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const resData = await response.json();

        if (!response.ok || !resData.success) {
            throw new Error(
                resData?.error || resData?.message || 'Failed to request demo'
            );
        }

        return resData;
    } catch (error) {
        console.error('Error requesting demo:', error);
        throw error;
    }
};